import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, REGULAR_PRICE, TODAY_PRICE } from '../data/product';
const seeSteps = ['See it.', 'Choose it.', 'Adapt it.', 'Coach it.'];
const recap = ['250+ Exercises & Movements', '100 Ready-to-Use Sessions', '12-Month Programming', '6 Professional Modules', '5 Premium Bonuses'];
export function FinalCTA() {
  return <section className="bg-ink text-white px-4 sm:px-6 py-9 sm:py-12" data-id="element-47" data-mp="m4ow4a3kv5bh">
      <div className="max-w-2xl mx-auto text-center" data-id="element-48" data-mp="m2voosl54h2f">
        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight mb-2.5" data-id="element-49" data-mp="h4u4u5fw4dpw">
          Next week is coming either way.
        </h2>

        <p className="font-heading font-semibold uppercase text-[11px] sm:text-sm tracking-wide text-lime leading-snug max-w-xl mx-auto mb-5" data-id="element-50" data-mp="qv577njxeeuo">
          The question is whether you want to build everything again.
        </p>

        <p className="text-[13px] sm:text-base text-white/70 leading-relaxed max-w-lg mx-auto mb-2" data-id="element-51" data-mp="zxegka3gk26h">
          You already have the coaching experience. You don't need more
          scattered ideas. You need an organized system behind what you already
          know.
        </p>

        <p className="text-[13px] sm:text-base text-white/70 leading-relaxed max-w-lg mx-auto mb-4" data-id="element-52" data-mp="2m2kuycuc1afx">
          Fitness Senior Ready™ gives you the visual exercises, complete
          classes, circuits, activities, progressions and programming to make
          that process easier.
        </p>

        <ul className="flex justify-center gap-2 sm:gap-4 mb-5" data-id="element-53" data-mp="3023nhxanud74">
          {seeSteps.map(step => <li key={step} className="font-heading font-extrabold uppercase text-[10px] sm:text-xs tracking-[0.12em] text-lime" data-id="element-54" data-mp="34t27p7yrrvfn">
              {step}
            </li>)}
        </ul>

        <ul className="flex flex-wrap justify-center gap-1.5 mb-6" data-id="element-55" data-mp="3et2wh9fer3r8">
          {recap.map(item => <li key={item} className="rounded bg-white/[0.06] border border-white/10 px-2 py-1 text-[10px] sm:text-xs font-semibold text-white/85" data-id="element-56" data-mp="3itd0whnjxm3z">
              {item}
            </li>)}
        </ul>

        <div className="bg-white/[0.05] border border-lime/30 rounded-xl p-4 max-w-xs sm:max-w-sm mx-auto mb-4" data-id="element-57" data-mp="1sh6u1n1gcdx3">
          <h3 className="font-heading font-extrabold uppercase text-sm sm:text-lg tracking-tight mb-2" data-id="element-58" data-mp="1npotv1796hd6">
            Fitness Senior Ready™
          </h3>
          <p className="text-[12px] line-through text-white/40 mb-0.5" data-id="element-59" data-mp="22gnw7uhhw9ob">
            {REGULAR_PRICE}
          </p>
          <p className="font-heading font-bold text-[9px] sm:text-[11px] uppercase tracking-[0.16em] text-lime" data-id="element-60" data-mp="2bfj5xgjr01wd">
            Today:
          </p>
          <p className="font-heading font-black text-2xl sm:text-4xl leading-none mb-2" data-id="element-61" data-mp="27f8w1ssu4rc8">
            {TODAY_PRICE}
          </p>
          <p className="font-heading font-bold text-[9px] sm:text-[11px] uppercase tracking-[0.12em] text-gold" data-id="element-62" data-mp="h3ktz6u20rws">
            One payment. Lifetime access.
          </p>
        </div>

        <div className="max-w-xs sm:max-w-sm mx-auto mb-2.5" data-id="element-63" data-mp="2whrcqyrgg2n">
          <CTAButton href={CHECKOUT_URL} data-id="element-64" data-mp="6xtacdn4q31v">
            Yes — I want my senior fitness system
          </CTAButton>
        </div>

        <p className="text-[10px] sm:text-xs font-semibold text-white/50 tracking-wide" data-id="element-65" data-mp="3pb17as3dw3b8">
          Instant Access · Secure Payment · 7-Day Guarantee
        </p>
      </div>
    </section>;
}